import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import EmployeeOrder from "@/pages/EmployeeOrder";
import Inventory from "@/pages/Inventory";
import History from "@/pages/History";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App font-sans">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EmployeeOrder />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/history" element={<History />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { borderRadius: "14px", fontFamily: "DM Sans, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
